var _excluded = ["onChange", "value", "maskType", "allowDecimal", "allowZero", "integerLimit", "valueLimit", "showIcon", "iconBackgroundColor", "className", "disabled"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import NumberFormat from "react-number-format"; // https://github.com/s-yadav/react-number-format

import Icon from "../elements/icon";

var getMask = function getMask(_ref) {
  var type = _ref.type,
      allowDecimal = _ref.allowDecimal;

  switch (type) {
    case "currency":
      return {
        mask: {
          thousandSeparator: true,
          decimalScale: allowDecimal ? 2 : 0
        },
        icon: /*#__PURE__*/React.createElement(Icon, {
          icon: "dollar"
        }),
        iconAlignment: "align-left"
      };

    case "percent":
      return {
        mask: {
          thousandSeparator: true,
          decimalScale: allowDecimal ? 2 : 0
        },
        icon: /*#__PURE__*/React.createElement(Icon, {
          icon: "percent"
        }),
        iconAlignment: "align-right"
      };

    case "year":
      return {
        mask: {
          thousandSeparator: false,
          decimalScale: 0
        }
      };

    default:
      return {
        mask: {
          thousandSeparator: true,
          decimalScale: allowDecimal ? 2 : 0
        }
      };
  }
};

var NumericInput = function NumericInput(_ref2) {
  var onChange = _ref2.onChange,
      value = _ref2.value,
      maskType = _ref2.maskType,
      allowDecimal = _ref2.allowDecimal,
      _ref2$allowZero = _ref2.allowZero,
      allowZero = _ref2$allowZero === void 0 ? true : _ref2$allowZero,
      integerLimit = _ref2.integerLimit,
      valueLimit = _ref2.valueLimit,
      showIcon = _ref2.showIcon,
      iconBackgroundColor = _ref2.iconBackgroundColor,
      className = _ref2.className,
      disabled = _ref2.disabled,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var _getMask = getMask({
    type: maskType,
    allowDecimal: allowDecimal
  }),
      mask = _getMask.mask,
      icon = _getMask.icon,
      iconAlignment = _getMask.iconAlignment;

  var iconColor = value ? {
    backgroundColor: iconBackgroundColor
  } : {};

  var withPreventZero = function withPreventZero(val) {
    return val !== 0;
  };

  var withValueLimit = function withValueLimit(val) {
    return !val || val <= valueLimit;
  };

  var withIntegerLimit = function withIntegerLimit(val) {
    return Math.trunc(val).toString().length <= integerLimit;
  };

  var iconLeft = showIcon && iconAlignment === "align-left";
  var iconRight = showIcon && iconAlignment === "align-right";
  var inputAlignClass = showIcon ? "et--numeric-input--".concat(iconAlignment) : "";
  var iconClassNames = classNames("et--numeric-input--icon", value ? "et--numeric-input--active" : "");

  var isValidValue = function isValidValue(value) {
    var checkValueLimit = valueLimit ? withValueLimit(value) : true;
    var checkIntegerLimit = integerLimit ? withIntegerLimit(value) : true;
    var checkAllowZero = !allowZero ? withPreventZero(value) : true;
    var isValid = checkValueLimit && checkIntegerLimit && checkAllowZero;
    return isValid;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames("et--numeric-input", inputAlignClass)
  }, iconLeft && /*#__PURE__*/React.createElement("span", {
    style: iconColor,
    className: iconClassNames
  }, icon), /*#__PURE__*/React.createElement(NumberFormat, _extends({
    value: value,
    disabled: disabled,
    className: className,
    onValueChange: function onValueChange(_ref3) {
      var floatValue = _ref3.floatValue;
      return onChange(floatValue === undefined ? null : floatValue);
    },
    allowNegative: false,
    isAllowed: function isAllowed(_ref4) {
      var floatValue = _ref4.floatValue;
      return isValidValue(floatValue);
    }
  }, mask, rest)), iconRight && /*#__PURE__*/React.createElement("span", {
    style: iconColor,
    className: iconClassNames
  }, icon));
};

NumericInput.propTypes = {
  onChange: PropTypes.func,
  maskType: PropTypes.oneOf(["currency", "percent", "number", "year"]),
  allowZero: PropTypes.bool,
  allowDecimal: PropTypes.bool,
  showIcon: PropTypes.bool,
  integerLimit: PropTypes.number,
  valueLimit: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  iconBackgroundColor: PropTypes.string
};
export default NumericInput;